import Script from "next/script";

declare global {
  interface Window {
    dataLayer: any[];
    fbq: (...args: any[]) => void;
    rdt: (...args: any[]) => void;
    uipe: (...args: any[]) => void;
  }
}

const TrackingScripts = () => {
  return (
    <>
      <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-JZE2T8F8ME"
      />
      <Script
        id="datalayer"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-JZE2T8F8ME');
          `,
        }}
      />
      <Script
        id="reddit"
        dangerouslySetInnerHTML={{
          __html: `
        !(function (w, d) {
          if (!w.rdt) {
            var p = (w.rdt = function () {
              p.sendEvent
                ? p.sendEvent.apply(p, arguments)
                : p.callQueue.push(arguments);
            });
            p.callQueue = [];
            var t = d.createElement('script');
            (t.src = 'https://www.redditstatic.com/ads/pixel.js'), (t.async = !0);
            var s = d.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(t, s);
          }
        })(window, document);
        rdt('init', 't2_svkzlzgg', {
          optOut: false,
          useDecimalCurrencyValues: true,
          email: 'caleb@privateauto.com',
        });
        rdt('track', 'PageVisit');
      `,
        }}
      />
      <Script
        id="gtag0"
        dangerouslySetInnerHTML={{
          __html: `
            !(function (f, b, e, v, n, t, s) {
              if (f.fbq) return;
              n = f.fbq = function () {
                n.callMethod
                  ? n.callMethod.apply(n, arguments)
                  : n.queue.push(arguments);
              };
              if (!f._fbq) f._fbq = n;
              n.push = n;
              n.loaded = !0;
              n.version = '2.0';
              n.queue = [];
              t = b.createElement(e);
              t.async = !0;
              t.src = v;
              s = b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t, s);
            })(
              window,
              document,
              'script',
              'https://connect.facebook.net/en_US/fbevents.js'
            );
            fbq('init', '218912453111725');
            fbq('track', 'PageView');
            `,
        }}
      />
      <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-JZE2T8F8ME"
      />
      <Script
        id="gtag"
        dangerouslySetInnerHTML={{
          __html: `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-JZE2T8F8ME');`,
        }}
      />
      <Script
        id="gtag1"
        dangerouslySetInnerHTML={{
          __html: `(function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "GTM-NF432VS");`,
        }}
      />

      {/* Google Ads and HelpScout Beacon were served from Strapi header-elements
          until the VDP was cut off Strapi (PA-6658). */}
      <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=AW-10848315657"
      />
      <Script
        id="google-ads"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-10848315657');
          `,
        }}
      />
      <Script
        id="helpscout-beacon"
        dangerouslySetInnerHTML={{
          __html: `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
            setTimeout(() => {window.Beacon('init', '380a715f-9081-492d-a844-62867fed167c')}, 500);`,
        }}
      />

      <Script
        async
        src="https://app.ablecdp.com/pjs/3c2799a7-833e-4e75-a50a-8a2b0628bc98.js"
      />

      <Script
        id="ablecdp-script"
        dangerouslySetInnerHTML={{
          __html: `document.addEventListener('DOMContentLoaded', (event) => {
            uipe('init', '3c2799a7-833e-4e75-a50a-8a2b0628bc98');
            uipe('track', 'PageView');
        });
    `,
        }}
      />
    </>
  );
};

export default TrackingScripts;
